import Navbar from "../components/header/Navbar"
import Sidebar from "../components/header/Sidebar"
import Hero from "../components/hero/Hero"
import OurFeatures from "../components/our_features/OurFeatures"
import HowItWorks from "../components/how_it_works/HowItWorks"
import GetStarted from "../components/get_started/GetStarted"
import Footer from "../components/footer/Footer"
import Pricing from "../components/pricing/Pricing"
import {useGlobalContext} from "../contexts/global_context"
import {Helmet} from "react-helmet";
import React from "react";
import {DEFAULT_META_DESCRIPTION} from "../data/head";
import HeaderNotification from "../components/notification/HeaderNotification";
import {BRAND_BASE_URL, BRAND_LOGO_FOLDER, BRAND_NAME} from "../data/config";

const IndexPage = () => {
  let {groupedCategories} = useGlobalContext()

  return <>
    {/* SEO */}
    <Helmet>
      <title>{BRAND_NAME}: Real Likes, Followers, Views & More | Now $3.99</title>
      <meta name="description" content={DEFAULT_META_DESCRIPTION}/>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: BRAND_NAME,
          url: BRAND_BASE_URL,
          logo: `${BRAND_BASE_URL}/branding/${BRAND_LOGO_FOLDER}/logo-square.png`,
          sameAs: [
          ]
        })}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: BRAND_NAME,
          url: BRAND_BASE_URL,
          potentialAction: {
            '@type': 'SearchAction',
            target: `${BRAND_BASE_URL}/?q={search_term_string}`,
            'query-input': 'required name=search_term_string'
          }
        })}
      </script>
    </Helmet>

    <HeaderNotification/>
    <Navbar/>
    <Sidebar/>
    <Hero groupedCategories={groupedCategories}/>
    <OurFeatures/>
    <HowItWorks/>
    <Pricing showTabs={true} groupedCategories={groupedCategories}/>
    <GetStarted
      title={'Other Great Services'}
      description={
        'Choose one of the options below to get started. ' +
        'Your fantastic likes, followers, views and comments are only a few clicks away!'
      }
      groupedCategories={groupedCategories}
    />
    <Footer/>
  </>
}

export default IndexPage
